const UserMarketingConsentEnum = Object.freeze({
    HARDNO: 'HARDNO',
    HARDYES: 'HARDYES'
});

export default UserMarketingConsentEnum;
